import React, { useContext } from 'react';
import cn from 'classnames';

import { OfficeContext } from './Office';
import OfficeFloorPlan from './OfficeFloorPlan';
import OfficeSpaceList from './OfficeSpaceList';
import OfficeOpenSeating from './OfficeOpenSeating';
import OfficeClock from './OfficeClock';
import OfficeRoster from './OfficeRoster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';

const OfficeTab = () => {
  const ctx = useContext(OfficeContext);
  const {
    floors,
    spaces,
    selectedDateAnnouncement,
    selectedFloorId,
    setSelectedFloorId,
    viewMode,
    setViewMode,
    setSelectedSpace,
    focusedUserFloorIds
  } = ctx;

  const floorSpaces = spaces.filter(s => s.type !== 'open_seating');
  const openSeating = spaces.filter(s => s.type === 'open_seating');

  return (
    <div className='office-tab'>
      <header className='office-header'>
        <div className='office-time-bar'>
          <OfficeClock />
        </div>

        <div className='office-controls'>
          <div className='office-controls-left'>
            <div className='office-floor-tabs'>
              {floors.map(floor => (
                <button
                  key={floor.id}
                  className={cn('office-floor-tab', {
                    active: selectedFloorId === floor.id,
                    'user-on-floor': focusedUserFloorIds.length > 0 && focusedUserFloorIds.includes(floor.id) && selectedFloorId !== floor.id
                  })}
                  onClick={() => {
                    setSelectedFloorId(floor.id);
                    setSelectedSpace(null);
                  }}
                >
                  {floor.name || `Floor ${floor.floor}`}
                </button>
              ))}
            </div>
          </div>
          <div className='office-view-toggle'>
            <button className={cn('view-btn', { active: viewMode === 'map' })} onClick={() => setViewMode('map')}>
              Map
            </button>
            <button className={cn('view-btn', { active: viewMode === 'list' })} onClick={() => setViewMode('list')}>
              List
            </button>
          </div>
        </div>

        {selectedDateAnnouncement && (
          <div className='office-announcement'>
            <FontAwesomeIcon icon={faInfoCircle} size='lg' />
            <p className='office-announcement-title'>{selectedDateAnnouncement.title}</p>
            <p className='office-announcement-description'>{selectedDateAnnouncement.description}</p>
          </div>
        )}
      </header>

      <div className='office-main'>
        <div className='office-main-content'>
          {viewMode === 'map' ? <OfficeFloorPlan spaces={floorSpaces} /> : <OfficeSpaceList spaces={floorSpaces} />}
        </div>
        <OfficeRoster />
      </div>

      {openSeating.map(seat => (
        <OfficeOpenSeating key={seat.id} space={seat} />
      ))}
    </div>
  );
};

export default OfficeTab;
